import React, { useEffect, useRef, useState } from 'react';
import './ProfilePopup.css';
import gsap from 'gsap';
import rockBg from '../../asserts/rockbg.png';
import Btn3 from '../common/Btn3';
import avatarImg from '../../asserts/avatar.png';
import heartImg from '../../asserts/heart.png';
import coinImg from '../../asserts/coin.png';
import './PopupShared.css';

const ProfilePopup = ({ onClose }) => {
  const scrollRef = useRef();
  const contentRef = useRef();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(() => localStorage.getItem('playerName') || 'Shadow');
  const [tempName, setTempName] = useState('');

  useEffect(() => {
    gsap.set(scrollRef.current, {
      rotation: 60,
      rotationX: -40,
      opacity: 0,
      transformOrigin: 'center center',
      transformPerspective: 1400,
      x: 100,
      y: 820,
      scale: 0.8,
    });

    const tl = gsap.timeline();
    tl.to(scrollRef.current, {
      rotation: 0,
      rotationX: 0,
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
      duration: 1.3,
      ease: 'power3.out',
    }).fromTo(
      contentRef.current.querySelectorAll('.popup-animate'),
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out' },
      '-=0.4'
    );
  }, []);

  const handleClose = () => {
    const tl = gsap.timeline({ onComplete: onClose });
    tl.to(contentRef.current.querySelectorAll('.popup-animate'), {
      opacity: 0,
      y: 20,
      duration: 0.25,
      stagger: 0.06,
      ease: 'power2.in',
    }).to(scrollRef.current, {
      rotation: -20,
      rotationX: 40,
      opacity: 0,
      x: -200,
      y: 120,
      scale: 0.8,
      duration: 1,
      ease: 'power3.in',
    }, '-=0.1');
  };

  const handleSave = () => {
    const trimmed = tempName.trim() || name;
    setName(trimmed);
    localStorage.setItem('playerName', trimmed);
    setEditing(false);
  };

  return (
    <div className="popup-overlay">
      <div className="popup-scroll" ref={scrollRef} style={{ backgroundImage: `url(${rockBg})` }}>
        <div className="popup-inner" ref={contentRef}>
          <h2 className="popup-title popup-animate">Profile</h2>
          <div className="profile-row popup-animate">
            <div className="profile-left">
              <div className="profile-avatar">
                <img src={avatarImg} alt="" />
              </div>
              <div className="profile-info">
                {editing ? (
                  <div className="profile-edit-row">
                    <input
                      className="profile-name-input"
                      value={tempName}
                      onChange={(e) => setTempName(e.target.value)}
                      autoFocus
                    />
                    <button className="profile-save-btn" onClick={handleSave}>✓</button>
                  </div>
                ) : (
                  <button className="profile-name-btn" onClick={() => { setTempName(name); setEditing(true); }}>
                    {name}
                  </button>
                )}
                <div className="profile-coins">
                  <img src={coinImg} alt="" />
                  <img src={coinImg} alt="" />
                  <img src={coinImg} alt="" />
                </div>
              </div>
            </div>
            <div className="profile-right">
              <img src={heartImg} alt="" className="profile-heart" />
              <span className="profile-fragment">0 Fragment</span>
            </div>
          </div>
          <div className="popup-back popup-animate">
            <Btn3 onClick={handleClose} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePopup;